import { NumberFormatProps } from 'react-number-format'

export type NumberFormat = 'euro' | 'euroInt' | 'number' | 'fraction' | 'hours' | 'minutes' | 'percentage' | 'text'
type NumberFormatConfig = NumberFormatProps & { multiplier?: number }

const euroConfig: NumberFormatConfig = {
  prefix: '',
  suffix: ' €',
  decimalScale: 2,
  fixedDecimalScale: true,
  multiplier: 1,
  thousandSeparator: '.',
  decimalSeparator: ',',
}

export const formats: Record<NumberFormat, NumberFormatConfig> = {
  euro: { ...euroConfig },
  euroInt: { ...euroConfig, decimalScale: 0 },
  number: {
    prefix: '',
    suffix: '',
    decimalScale: 0,
    fixedDecimalScale: true,
    multiplier: 1,
  },
  fraction: {
    prefix: '',
    suffix: '',
    decimalScale: 2,
    fixedDecimalScale: true,
    multiplier: 1,
  },
  hours: {
    prefix: '',
    suffix: 'h',
    decimalScale: 2,
    fixedDecimalScale: true,
    multiplier: 1,
  },
  minutes: {
    prefix: '',
    suffix: ' min',
    decimalScale: 0,
    fixedDecimalScale: true,
    multiplier: 1,
  },
  percentage: {
    prefix: '',
    suffix: '%',
    decimalScale: 1,
    fixedDecimalScale: false,
    multiplier: 100,
  },
  // add empty formatting rules for text since we have text format here
  // src/pages/DrilldownReport/components/data.ts
  text: {} as NumberFormatProps,
}

export const getSecurityEnv = (): 'staging' | 'production' => {
  if (window.location.host.startsWith('localhost') || window.location.host.startsWith('staging')) {
    return 'staging'
  }
  return 'production'
}
